import * as React from 'react'
import Tooltip from 'react-tooltip'

interface Props {
  title: string
  description?: string
  tooltip?: string
  checked: boolean
  onClick: () => void
}

export class ModifyReasonCard extends React.Component<Props, {}> {
  render() {
    return (
      <div
        className='card h-100'
        onClick={() => this.props.onClick()}
        style={{ cursor: 'pointer', backgroundColor: this.props.checked ? '#D4EDDA' : '' }}
      >
        <div className='card-body d-flex'>
          <div style={{ flexGrow: 1 }}>
            <b className='mr-2'>{this.props.title}</b>
            {!!this.props.tooltip && (
              <>
                <span
                  data-tip
                  data-for={this.props.title}
                  className='fa fa-info-circle m4-2'
                  style={{ cursor: 'pointer' }}
                />
                <Tooltip place='right' id={this.props.title} effect='solid'>
                  {this.props.tooltip}
                </Tooltip>
              </>
            )}
            {!!this.props.description && <div className='text-muted'>{this.props.description}</div>}
          </div>
          <div>
            <span
              className={
                'fa fa-check-circle ' + (this.props.checked ? 'text-success' : 'text-light')
              }
            />
          </div>
        </div>
      </div>
    )
  }
}
